import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Alert,
  Pagination,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { changeSubmitDate, displayYmdHis } from "assets/js/common";
import axios from "axios";
import CustomLocale from "customLocale"; //datepicker locale 기본설정
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";

const StyleScope = styled.div`
  .MuiDataGrid-root .MuiDataGrid-columnHeaderTitle {
    width: 100%;
    text-align: center;
  }

  .MuiGrid-container {
    align-items: center;
  }

  .MuiDataGrid-cell {
    text-align: center;
  }

  .MuiDataGrid-cell--withRenderer {
    justify-content: center !important;
    text-align: center;
    line-height: 20px !important;
  }

  .ymdHis-container {
    white-space: break-spaces;
  }

  .link-btn {
    margin-left: 5px;
  }
`;

const useStyles = makeStyles((theme) => ({
  deleteItemButton: {
    background: "none",
    border: "none",
    padding: "5px",
    "min-width": "15px",
    "&:hover": {
      background: "none",
      border: "none",
    },
    "& span": {
      width: "auto",
    },
    "& img": {
      width: "15px",
    },
  },
}));

const displayCatg = function(val) {
  switch (val) {
    case "1":
      return "학술자료";
    case "2":
      return "대리점공지";
    case "3":
      return "홍보물";
    case "4":
      return "Ecampus";
    default:
      return "-";
  }
};

export default function NoticeManagement() {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [rows, setRows] = useState([]);
  const [dialogData, setDialogData] = useState("");
  const [alertMode, setAlertMode] = useState("");
  const [delSeq, setDelSeq] = useState("");
  const [answer, setAnswer] = useState("");

  const [inquiryData, setInquiryData] = useState({
    inquiryList: {
      totalPageSize: 1,
      totalSize: 0,
      number: 0,
    },
  });

  const [schForm, setSchForm] = useState({
    schStrtYmd: "",
    schEndYmd: "",
    schInqrTp: "",
    schYmdTp: "whle",
    schFld: "whle",
    schTxt: "",
    pg: 1,
    pgSz: 20,
    sordFld: "rgstYmd",
    sordMetd: "DESC",
  });

  const columns = [
    {
      field: "id",
      headerName: "번호",
      headerAlign: "center",
      sortable: false,
      width: 55,
      disableColumnMenu: true,
      valueGetter: (params) => {
        return `${inquiryData.inquiryList.number - params.row.index}`;
      },
    },
    {
      field: "tp",
      headerName: "접속자",
      headerAlign: "center",
      sortable: false,
      width: 80,
      disableColumnMenu: true,
      renderCell: (params) => displayCatg(params.value),
    },
    {
      field: "inqrDept",
      headerName: "IP",
      headerAlign: "center",
      sortable: false,
      width: 100,
      disableColumnMenu: true,
    },
    {
      field: "inqrNm",
      headerName: "로그인 일시",
      headerAlign: "center",
      sortable: false,
      width: 80,
      disableColumnMenu: true,
    },
    {
      field: "inqrTtl",
      headerName: "로그아웃 일시",
      headerAlign: "center",
      sortable: true,
      width: 180,
      disableColumnMenu: true,
      renderCell: (params) => (
        <>
          {params.value}
          <Button
            className={classes.deleteItemButton + " mx-2"}
            size="small"
            color="primary"
            variant="outlined"
            onClick={() => window.open(params.row.orgnLink, "_blank")}
          >
            <img src="/images/icon/link.png" alt="링크 이동" />
          </Button>
        </>
      ),
    },
  ];

  const items = [];
  const {
    formState: { errors, submitCount },
    register,
    handleSubmit,
    reset,
  } = useForm();

  const handleDialogOpen = (data) => {
    //dialog open
    reset();
    setAnswer("");

    axios.get(`/api/cit/inquiry/get/${data.seq}`).then((res) => {
      setDialogData(res.data.data.inquiry);
      setDialogOpen(true);
    });
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const fetchData = () => {
    axios
      .get("/api/cit/inquiry", {
        params: {
          ...schForm,
          schStrtYmd: changeSubmitDate(schForm.schStrtYmd),
          schEndYmd: changeSubmitDate(schForm.schEndYmd),
        },
      })
      .then((res) => {
        let list = res.data.data.inquiryList.list;

        list.map((item, i) => {
          item.id = item.seq;
          item.index = i;
        });

        setRows(list);
        setInquiryData(res.data.data);
      });
  };

  useEffect(() => {
    setRows(items);
  }, []);
  // mount

  useEffect(() => {}, [errors]);

  useEffect(() => {
    fetchData();
  }, [schForm]);

  useEffect(() => {}, [dialogOpen]);

  const handleChangeInput = (event) => {
    const target = event.target;
    const name = target.name;

    setSchForm((prev) => ({
      ...prev,
      [name]: target.value,
    }));
  };

  const handleChangeDatePicker = (name) => (value) => {
    setSchForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangePage = (e, value) => {
    setSchForm((prev) => ({
      ...prev,
      pg: value,
    }));
  };

  const handleChangeAnswer = ({ target }) => {
    //dialog check
    setAnswer(target.value);

    // if (target.value.length >= 300) {
    //   target.value = target.value.slice(0, 300);
    //   handleAlertOpen("length");
    // }
  };

  const handleDelete = (e) => {
    axios
      .post("/api/cit/inquiry/remove", null, {
        params: {
          seq: delSeq,
        },
      })
      .then((res) => {
        fetchData();
        handleModalClose();
      });
  };

  const handleModify = (e) => {
    handleModalClose();

    axios
      .post("/api/cit/inquiry/regist-answer", {
        seq: dialogData.seq,
        // ansrId: "",
        // ansrNm: "",//어디서가지고올지?
        ansrCont: answer,
      })
      .then((res) => {
        setTimeout(() => {
          handleAlertOpen("compelete");
        }, 100);
        fetchData();
      });
  };

  const [openModal, setOpenModal] = React.useState(false);
  const handleAlertOpen = (mode, seq) => {
    setAlertMode(mode);
    setDelSeq(seq);
    setOpenModal(true);
  };
  const handleModalClose = () => {
    setOpenModal(false);
  };

  const onSubmit = (data) => {
    setAnswer(data.answer);

    if (answer != null && dialogData.ansrCont != null) {
      handleAlertOpen("already");
    } else {
      //답변 등록 api
      axios
        .post("/api/cit/inquiry/regist-answer", {
          seq: dialogData.seq,
          // ansrId: "",
          // ansrNm: "",
          ansrCont: data.answer,
        })
        .then((res) => {
          handleAlertOpen("compelete");
          fetchData();
        });
    }
  };

  return (
    <main id="main">
      <div className="h-group">
        <h2>공지사항관리</h2>
      </div>

      <div className="search-box">
        <table className="search-table">
          <tbody>
            <tr>
              <th scope="row">
                <InputLabel htmlFor="searchRange">로그인 일자</InputLabel>
              </th>
              <td colSpan="3">
                <DatePicker
                  name="schStrtYmd"
                  value={schForm.schStrtYmd}
                  onChange={handleChangeDatePicker("schStrtYmd")}
                  maximumDate={schForm.schEndYmd}
                  inputPlaceholder="Select Date"
                  wrapperClassName="custom-datepicker"
                  formatInputText={() => {
                    return CustomLocale.formatInputText(schForm.schStrtYmd);
                  }}
                  locale={CustomLocale}
                />
                <span> ~ </span>
                <DatePicker
                  name="schEndYmd"
                  value={schForm.schEndYmd}
                  onChange={handleChangeDatePicker("schEndYmd")}
                  minimumDate={schForm.schStrtYmd}
                  inputPlaceholder="Select Date"
                  wrapperClassName="custom-datepicker"
                  formatInputText={() => {
                    return CustomLocale.formatInputText(schForm.schEndYmd);
                  }}
                  locale={CustomLocale}
                />
                <RadioGroup
                  name="schInqrTp"
                  value={schForm.schInqrTp}
                  row
                  onChange={handleChangeInput}
                >
                  <FormControlLabel
                    value=""
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                      />
                    }
                    label="7일"
                  />
                  <FormControlLabel
                    value="1"
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                      />
                    }
                    label="30일"
                  />
                  <FormControlLabel
                    value="2"
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                      />
                    }
                    label="90일"
                  />
                </RadioGroup>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel htmlFor="keyword">검색</InputLabel>
              </th>
              <td colSpan="3">
                <Grid container spacing={1}>
                  <Grid item xs={1}>
                    <Select
                      name="schFld"
                      inputProps={{
                        className: [!schForm.schFld && "select-placeholder"],
                      }}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: 30,
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                      fullWidth
                      displayEmpty
                      value={schForm.schFld}
                      onChange={handleChangeInput}
                    >
                      <MenuItem value={"whle"}>전체</MenuItem>
                      <MenuItem value={"inqrDept"}>접속자</MenuItem>
                      <MenuItem value={"inqrNm"}>IP</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      name="schTxt"
                      placeholder="검색어를 입력해주세요."
                      className="ms-2"
                      value={schForm.schTxt}
                      onChange={handleChangeInput}
                    />
                  </Grid>
                </Grid>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="search-btn-wrap">
          <Button variant="contained" color="secondary">
            초기화
          </Button>
          <Button variant="contained" color="primary">
            검색
          </Button>
        </div>
      </div>

      <Grid container className="inline-form">
        <Grid item xs={6}>
          <div className="total-count-wrap">
            <span>검색</span>
            <span className="text-primary">
              {inquiryData.inquiryList.totalSize}
            </span>
            <span>건</span>
          </div>
        </Grid>
        <Grid item xs={6} className="inner-form-wrap">
          <Box display="flex" justifyContent="end">
            <FormControl className="MuiFormControl-wrap">
              <Select
                name="pgSz"
                value={schForm.pgSz}
                onChange={handleChangeInput}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 50,
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value={5}>5개 씩</MenuItem>
                <MenuItem value={10}>10개 씩</MenuItem>
                <MenuItem value={50}>50개 씩</MenuItem>
                <MenuItem value={100}>100개 씩</MenuItem>
                <MenuItem value={200}>200개 씩</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
      {/* ~~~~~~~~~~~~~~~~ data grid start ~~~~~~~~~~~~~~~~ */}
      <DataGrid
        headerHeight={32}
        rowHeight={60}
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={schForm.pgSz}
        rowsPerPageOptions={[5]}
        disableSelectionOnClick
        components={{
          NoRowsOverlay: () => (
            <div className="nodata-wrap">
              검색 결과 값이 없습니다. 다시 검색해주세요.
            </div>
          ),
        }}
      />
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Pagination
          name="pg"
          count={inquiryData.inquiryList.totalPageSize}
          color="primary"
          size="small"
          className="mt-2"
          onChange={handleChangePage}
        />
      </Box>
      {/* ~~~~~~~~~~~~~~~~ dialog start ~~~~~~~~~~~~~~~~ */}
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="customized-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)} className="custom-input-form">
          <DialogTitle id="customized-dialog-title">
            질의응답 답변 등록
          </DialogTitle>
          <DialogContent dividers>
            <Box fontSize="16px" sx={{ mb: 1 }}>
              질문 내용
            </Box>
            <table className="table">
              <tbody>
                <tr>
                  <th>
                    <InputLabel htmlFor="tp">구분</InputLabel>
                  </th>
                  <td>{displayCatg(dialogData.tp)}</td>
                </tr>
                <tr>
                  <th>
                    <InputLabel htmlFor="inqrDept">부서명</InputLabel>
                  </th>
                  <td>{dialogData.inqrDept}</td>
                </tr>
                <tr>
                  <th>
                    <InputLabel htmlFor="inqrNm">이름</InputLabel>
                  </th>
                  <td>{dialogData.inqrNm}</td>
                </tr>
                <tr>
                  <th>
                    <InputLabel htmlFor="inqrTtl">게시글 타이틀</InputLabel>
                  </th>
                  <td>
                    {dialogData.inqrTtl}
                    <Button
                      className={classes.deleteItemButton + " mx-2"}
                      size="small"
                      color="primary"
                      variant="outlined"
                      onClick={() => window.open(dialogData.orgnLink, "_blank")}
                    >
                      <img src="/images/icon/link.png" alt="링크 이동" />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <th>
                    <InputLabel htmlFor="inqrCont">질문내용</InputLabel>
                  </th>
                  <td>{dialogData.inqrCont}</td>
                </tr>
                <tr>
                  <th>
                    <InputLabel htmlFor="inqrYmd">질문일자</InputLabel>
                  </th>
                  <td>
                    {displayYmdHis(dialogData.inqrYmd, dialogData.inqrHis)}
                  </td>
                </tr>
                <tr>
                  <th>
                    <InputLabel htmlFor="ansrCont">답변내용</InputLabel>
                  </th>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: dialogData.ansrCont
                          ? dialogData.ansrCont.split("\n").join("<br />")
                          : "-",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    <InputLabel htmlFor="ansrYmd">답변일자</InputLabel>
                  </th>
                  <td>
                    {displayYmdHis(dialogData.ansrYmd, dialogData.ansrHis)}
                  </td>
                </tr>
              </tbody>
            </table>
            <Box fontSize="16px" sx={{ mt: 3, mb: 1 }}>
              답변
            </Box>
            <table className="table">
              <tbody>
                <tr>
                  <th>
                    <InputLabel htmlFor="answer">답변</InputLabel>
                  </th>
                  <td
                    style={{
                      height: "auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        padding: "7px 0 7px 0",
                      }}
                    >
                      <TextField
                        value={answer}
                        multiline
                        maxRows={8}
                        fullWidth
                        inputProps={{
                          className: [
                            !errors.answer &&
                              submitCount > 0 &&
                              "valid-confirm",
                          ],
                        }}
                        placeholder="답변 내용을 입력해주세요.
                                    "
                        {...register("answer", {
                          required: true,
                          maxLength: 300,
                        })}
                        onInput={handleChangeAnswer}
                      />
                      {errors.answer?.type === "required" && (
                        <FormHelperText className="text-danger">
                          답변을 입력해주세요.
                        </FormHelperText>
                      )}
                      {errors.answer?.type === "maxLength" && (
                        <FormHelperText className="text-danger">
                          최대 입력가능 문자 수를 초과했습니다.
                        </FormHelperText>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </DialogContent>
          <DialogActions>
            <Grid className={classes.buttonGroup2}>
              <Button variant="contained" onClick={() => handleDialogClose()}>
                취소
              </Button>
              <Button variant="contained" color="primary" type="submit">
                등록
              </Button>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
      {/* ~~~~~~~~~~~~~~~~ alert dialog start ~~~~~~~~~~~~~~~~ */}

      <Dialog
        id="alert-dialog"
        fullWidth={true}
        open={openModal}
        className="alert-dialog"
        onClose={handleModalClose}
        aria-labelledby="customized-dialog-title"
      >
        {alertMode == "length" ? (
          <>
            <DialogTitle id="customized-dialog-title">알림</DialogTitle>
            <DialogContent dividers>
              최대 입력가능 문자 수를 초과하였습니다.
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleModalClose()}
              >
                확인
              </Button>
            </DialogActions>
          </>
        ) : alertMode == "compelete" ? (
          <>
            <DialogTitle id="customized-dialog-title">알림</DialogTitle>
            <DialogContent dividers>답변이 등록되었습니다.</DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  handleModalClose();
                  handleDialogClose();
                }}
              >
                확인
              </Button>
            </DialogActions>
          </>
        ) : alertMode == "delete" ? (
          <>
            <DialogTitle id="customized-dialog-title">알림</DialogTitle>
            <DialogContent dividers>
              해당 질의응답을 삭제하시겠습니까?
            </DialogContent>
            <DialogActions>
              <Button variant="contained" onClick={() => handleModalClose()}>
                취소
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleDelete()}
              >
                확인
              </Button>
            </DialogActions>
          </>
        ) : (
          <>
            <DialogTitle id="customized-dialog-title">알림</DialogTitle>
            <DialogContent dividers>
              이미 등록된 답변이 있습니다.
              <br />
              답변을 수정하시겠습니까?
            </DialogContent>
            <DialogActions>
              <Button variant="contained" onClick={() => handleModalClose()}>
                취소
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => handleModify(e)}
              >
                확인
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </main>
  );
}
